import { ReactElement } from 'react';
import { Controller } from 'react-hook-form';
import { TextField as ToqioInput } from '@toqio/toqio-web-components';

import { ControllerRenderProps } from '../types/form';
import { RenderInputProps, InputProps } from './input.d';

export const RenderInput = (props: RenderInputProps): ReactElement => {
  const {
    placeholder = '',
    hint = '',
    label = '',
    disabled = false,
    id, // text field props
    inputRef,
    type = 'text',
    max,
    min, // input other props
    inputClassName = '',
    boxClassName = '',
    boxStyle = {},
    inputStyle = {}, // style props
    name = '',
    onChange,
    value = '',
    fieldState,
    role = 'textbox',
  }: RenderInputProps = props;

  return (
    <ToqioInput
      {...props}
      ref={inputRef}
      label={label}
      hint={hint}
      disabled={disabled}
      onChange={onChange}
      value={value}
      error={fieldState?.error?.message}
      placeholder={placeholder}
      type={type}
      min={min}
      max={max}
      className={boxClassName}
      style={boxStyle}
      inputClassName={inputClassName}
      inputStyle={inputStyle}
      role={role}
      ariaLabel={label ?? name}
      id={id ?? `form-input-${name}`}
    />
  );
};

export const Input = (props: InputProps): ReactElement => {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ field: { onChange, onBlur, value }, fieldState }: ControllerRenderProps): ReactElement => (
        <RenderInput
          fieldState={fieldState}
          onChange={onChange}
          onBlur={onBlur}
          value={value as string}
          {...props}
        />
      )}
    />
  );
};
